import { lazy } from 'react';
import { translation } from '@tools/translation';
import type { PageRouter } from '@tools/ui/types';

const SherlockTable = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../genericInbox/sherlockTable'
    )
);

const EscalationsTable = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../genericInbox/sherlockEscalationTable'
    )
);

export const organizationTasksRoutes: PageRouter[] = [
  {
    name: 'tasks',
    path: '/tasks',
    component: SherlockTable,
    displayName: translation.t('sherlock.tabs.orgLive'),
    exact: false,
    tabs: []
  },
  {
    name: 'pending',
    path: '/pending',
    component: SherlockTable,
    exact: false,
    tabs: []
  },
  {
    name: 'escalated',
    path: '/escalated',
    component: EscalationsTable,
    exact: false,
    tabs: []
  },
  {
    name: 'archive',
    path: '/archive',
    component: SherlockTable,
    exact: false,
    tabs: []
  }
];
